import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import formBlock from '@/components/molecules/Form/block.json';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type FormSectionBreakerProps = {
	title: string;
	formTheme?: any;
};

/**
 * COMPONENT
 */
export const FormSectionBreaker: FC<FormSectionBreakerProps> & BlockConfigs = ({
	title,
	formTheme = {},
	...rest
}) => {
	const { blockTheme: formBlockTheme } = useThemeBlock(
		formBlock.slug,
		formTheme
	);

	const rootClass = cx('supt-formSectionBreaker', getStyles(formBlockTheme));

	return (
		<div className={rootClass} data-block={block.slug} {...rest}>
			<h4 className="supt-formSectionBreaker__title">{title}</h4>
		</div>
	);
};

FormSectionBreaker.slug = block.slug;
FormSectionBreaker.title = block.title;
